export default {
  default: () => import("/home/tickets-r2ncy/tickets.dev2.on24.nl/client/layouts/default.vue").then(m => m.default || m)
}